export default {
  "20001": "操作失败",
  "40001": "认证失败，无法访问系统资源",
  "40003": "当前操作没有权限",
  "40004": "访问资源不存在",
  default: "系统未知错误，请反馈给管理员"
};
